import React from 'react';
import { Helmet } from 'react-helmet-async';
import ComparisonSection from '../components/ComparisonSection';
import Footer from '../components/Footer';
import FreeTrialBanner from '../components/FreeTrialBanner';
import Navbar from '../components/Navbar';
import PricingSection from '../components/PricingSection';
import ProjectDetailsSection from '../components/ProjectDetailsSection';
import ScreenshotsSection from '../components/ScreenshotsSection';
import HomeClosingSection from '../components/landing/HomeClosingSection';
import HomeLandingHero from '../components/landing/HomeLandingHero';
import HomePreviewBar from '../components/landing/HomePreviewBar';
import HomeValueProps from '../components/landing/HomeValueProps';

export default function Home() {
    return (
        <>
            <Helmet>
                <title>Helpigo - Pazaryeri Otomatik Soru Cevaplama | WhatsApp Soru Cevaplama</title>
                <meta name="description" content="WhatsApp, Hepsiburada, Çiçeksepeti ve diğer pazaryerlerinde otomatik soru cevaplama sistemi. Yapay zeka destekli müşteri hizmetleri ile satışlarınızı artırın. 7/24 otomatik cevap verme." />
                <meta name="keywords" content="pazaryeri otomatik soru cevaplama, whatsapp soru cevaplama, hepsiburada soru cevaplama, otomatik müşteri hizmetleri, yapay zeka chatbot, e-ticaret asistanı, pazaryeri yönetimi" />
                <link rel="canonical" href="https://www.helpigo.net/" />

                <meta property="og:title" content="Helpigo - Pazaryeri Otomatik Soru Cevaplama Sistemi" />
                <meta property="og:description" content="WhatsApp, Hepsiburada, Çiçeksepeti ve diğer pazaryerlerinde otomatik soru cevaplama sistemi. Yapay zeka destekli müşteri hizmetleri ile satışlarınızı artırın." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.helpigo.net/" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Helpigo - Pazaryeri Otomatik Soru Cevaplama Sistemi" />
                <meta name="twitter:description" content="WhatsApp, Hepsiburada, Çiçeksepeti ve diğer pazaryerlerinde otomatik soru cevaplama sistemi. Yapay zeka destekli müşteri hizmetleri ile satışlarınızı artırın." />
            </Helmet>

            <Navbar />
            <HomePreviewBar />
            <HomeLandingHero />
            <HomeValueProps />
            <ProjectDetailsSection />
            <ScreenshotsSection />
            <FreeTrialBanner />
            <PricingSection />
            <ComparisonSection />
            <HomeClosingSection />
            <Footer />
        </>
    );
}
